import React, { useRef } from 'react';
/** lib **/
import classNames from 'classnames';
import { OurFutureSliderItemList } from 'lib/our-futures-data';
import { useInViewFadeIn, useInViewFadeUp } from 'lib/use-in-view';
import { SERVICE_NAME } from '../../const';
/** components **/
import { ContentsTitle, OurFutureSliderItem } from '../molecules';
import { ParallaxItem } from 'components/organisms';
/** styles,images **/
import s from '../../styles/organisms/our-futures.module.scss';
import BgLogo from 'assets/images/bg-logo.svg';

export const OurFutures: React.FC = () => {
  const inViewRef1 = useRef<HTMLHeadingElement>(null);
  const inViewRef2 = useRef<HTMLHeadingElement>(null);
  const inViewRef3 = useRef<HTMLHeadingElement>(null);
  const inViewRef4 = useRef<HTMLHeadingElement>(null);
  const inViewRef5 = useRef<HTMLHeadingElement>(null);

  useInViewFadeIn([inViewRef1]);
  useInViewFadeUp([inViewRef2, inViewRef3, inViewRef4, inViewRef5], {
    rootMargin: '-10% 0px -10% 0px',
  });

  return (
    <div className={s.ourFuturesWrapper}>
      <ContentsTitle className={s.contentsTitles} title={`アイデア集`} />
      <div className={s.beforeFadeIn} ref={inViewRef1}>
        {/* <ContentsTitle className={s.contentsTitle} title={`OUR\nFEATURES`} subTitle="P-manの特徴" /> */}
      </div>

      {/* レスポンシブ対応の縦積みレイアウト */}
      <div className={s.simpleVerticalLayout}>
        {OurFutureSliderItemList.map((item, index) => (
          <div
            key={index}
            className={classNames(s.featureCard, s.beforeFadeUp)}
            ref={index === 0 ? inViewRef2 : index === 1 ? inViewRef3 : index === 2 ? inViewRef4 : inViewRef5}
          >
            <OurFutureSliderItem
              className={s.simpleItem}
              number={item.number}
              title={item.title}
              contents={item.contents}
              images={item.images}
              imagePosition={item.imagePosition as 'left' | 'bothEnds' | 'bothEndsDiffSize'}
              imageHeight={(item as any).imageHeight}
              showEquipment={(item as any).showEquipment}
            />
          </div>
        ))}
      </div>

      <ParallaxItem className={s.parallaxBg}>
        <img src={BgLogo} alt={SERVICE_NAME} width={381} height={500} />
      </ParallaxItem>
    </div>
  );
};
